import { SuggestionTypes } from "stentor-models";

export function getActionLabel(action: SuggestionTypes): string {
    if (typeof action === "string") {
        return action;
    }
    return action.title;
}
